import { useEffect, useState } from "react";

/**
 * Cycles through a list of words in place. Vertical flip with subtle blur.
 * The className is applied to EACH word so gradient styles like `grad-text`
 * can be composited per word (needed because background-clip:text does not
 * inherit through nested elements).
 */
export default function RotatingWords({
  words,
  interval = 2200,
  className = "",
  testId,
}) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!words?.length) return;
    const id = setInterval(() => setI((v) => (v + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words, interval]);
  const longest = words.reduce((a, b) => (a.length > b.length ? a : b), "");
  return (
    <span
      data-testid={testId}
      className="relative inline-flex overflow-hidden align-baseline"
      style={{ height: "1em" }}
    >
      {words.map((w, idx) => (
        <span
          key={w + idx}
          aria-hidden={idx !== i}
          className={`absolute inset-0 flex items-center transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${className} ${
            idx === i
              ? "opacity-100 translate-y-0 blur-0"
              : idx === (i - 1 + words.length) % words.length
              ? "opacity-0 -translate-y-full blur-sm"
              : "opacity-0 translate-y-full blur-sm"
          }`}
        >
          {w}
        </span>
      ))}
      {/* invisible ghost preserves width of the widest word */}
      <span className={`invisible whitespace-nowrap ${className}`}>{longest}</span>
    </span>
  );
}
